import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import { FaArrowLeft } from "react-icons/fa";
import alertify from "alertifyjs";

import "./styles/FeedBack.css";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import Footer from "../components/Footer";
import logo from "../assets/logo_celeste.png";
import * as actions from "../redux/actions/sessionActions";

const RATING_OPTIONS = [
  { value: 1, labelKey: "feedback_terrible", emoji: "😢", color: "#FFA98D" },
  { value: 2, labelKey: "feedback_bad", emoji: "😕", color: "#FFC385" },
  { value: 3, labelKey: "feedback_good", emoji: "😐", color: "#B8C4CC" },
  { value: 4, labelKey: "feedback_ok", emoji: "🙂", color: "#8FD4A8" },
  { value: 5, labelKey: "feedback_excellent", emoji: "😄", color: "#6BCB77" },
];

class Feedback extends React.Component {
  state = {
    comment: "",
    rating: null,
    submitting: false,
  };

  onChange = (e) => {
    this.setState({ comment: e.target.value });
  };

  onSelectRating = (rating) => {
    this.setState({ rating });
  };

  onClickBack = () => {
    if (window.history.length > 1) {
      this.props.history.goBack();
    } else {
      this.props.history.push("/panel/ads");
    }
  };

  onClick = async (e) => {
    e.preventDefault();

    const { comment, rating, submitting } = this.state;
    const { token } = this.props;

    if (submitting) return;

    if (!token) {
      alertify.error(I18n.t("warning_login"));
      return;
    }

    if (!rating) {
      alertify.error(I18n.t("feedback_select_rating"));
      return;
    }

    const ratingOption = RATING_OPTIONS.find((item) => item.value === rating);
    const ratingLabel = I18n.t(ratingOption.labelKey);
    const trimmedComment = comment.trim();
    const payload = trimmedComment
      ? `[${ratingLabel}] ${trimmedComment}`
      : `[${ratingLabel}]`;

    this.setState({ submitting: true });

    try {
      const result = await this.props.SendFeedBack(payload, token);
      if (result?.ok) {
        alertify.success(I18n.t("feedback_success"));
        this.props.history.push("/panel/ads");
      } else {
        alertify.error(I18n.t(result?.error || "try_later"));
      }
    } catch (error) {
      alertify.error(I18n.t("try_later"));
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const { comment, rating, submitting } = this.state;
    const { token } = this.props;

    return (
      <React.Fragment>
        <div className="feedback-page">
          <div className="feedback-card">
            <header className="feedback-card__header">
              <button
                type="button"
                className="feedback-card__back"
                onClick={this.onClickBack}
                aria-label={I18n.t("back")}
              >
                <FaArrowLeft />
                <span>
                  <Translate value="back" />
                </span>
              </button>
              <img
                src={logo}
                alt="Godiway"
                className="feedback-card__logo"
              />
              <h1 className="feedback-card__title">
                <Translate value="feedback_subtitle" />
              </h1>
              <p className="feedback-card__subtitle">
                <Translate value="feedback_better" />
              </p>
            </header>

            <form className="feedback-card__body" onSubmit={this.onClick}>
              <fieldset className="feedback-rating">
                <legend className="feedback-rating__legend">
                  <Translate value="feedback_subtitle" />
                </legend>
                <div className="feedback-rating__options">
                  {RATING_OPTIONS.map((option) => {
                    const isSelected = rating === option.value;
                    return (
                      <button
                        key={option.value}
                        type="button"
                        className={`feedback-rating__option${
                          isSelected ? " feedback-rating__option--selected" : ""
                        }`}
                        onClick={() => this.onSelectRating(option.value)}
                        aria-pressed={isSelected}
                        style={
                          isSelected
                            ? { "--rating-color": option.color }
                            : undefined
                        }
                      >
                        <span
                          className="feedback-rating__emoji"
                          aria-hidden="true"
                        >
                          {option.emoji}
                        </span>
                        <span className="feedback-rating__label">
                          <Translate value={option.labelKey} />
                        </span>
                      </button>
                    );
                  })}
                </div>
              </fieldset>

              <label className="feedback-comment" htmlFor="feedback-comment">
                <span className="feedback-comment__label">
                  <Translate value="comment_placeholder" />
                </span>
                <textarea
                  id="feedback-comment"
                  className="feedback-comment__input"
                  placeholder={I18n.t("comment_placeholder")}
                  value={comment}
                  onChange={this.onChange}
                  rows={5}
                  maxLength={2000}
                />
              </label>

              {!token && (
                <p className="feedback-login-hint">
                  <Translate value="store_reviews_login_hint" />
                </p>
              )}

              <button
                type="submit"
                className="feedback-submit"
                disabled={submitting || !token}
              >
                <Translate value="feedback_send" />
              </button>
            </form>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reducer) => ({
  token: reducer.session.auth.access_token,
});

const mapDispatchToProps = (dispatch) => ({
  SendFeedBack: (comment, token) =>
    dispatch(actions.sendFeedBack({ comment, token })),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Feedback)
);
